import { useInfiniteQuery } from '@tanstack/react-query';
import { getPascoRepository } from '@src/container';

export interface ListPascosParams {
    q?: string;
    status?: string;
    courseCode?: string;
    department?: string;
    level?: number;
    semester?: string;
    academicYear?: string;
    isInterimAssessment?: boolean;
    skip?: number;
    limit?: number;
}

export const useListPascosPaginated = (params: ListPascosParams = {}) => {
    const pascoRepository = getPascoRepository();

    return useInfiniteQuery({
        queryKey: ['pascos', 'list', params],
        queryFn: async ({ pageParam = 0 }) => {
            const skip = pageParam * (params.limit || 20);
            return pascoRepository.listPaginated({
                ...params,
                skip,
                limit: params.limit || 20,
            });
        },
        getNextPageParam: (lastPage, _, lastPageParam) => {
            return lastPage.hasMore ? lastPageParam + 1 : undefined;
        },
        initialPageParam: 0,
    });
};
